import { EXTERNAL_LINKS } from '@cast/constants';
import { Alert, Icons, SxProps, Typography } from '@cast/design-system';

type EksControlPlaneCostsAlertProps = {
  sx?: SxProps;
};

export const EksControlPlaneCostsAlert = ({
  sx,
}: EksControlPlaneCostsAlertProps) => {
  return (
    <Alert
      title="The costs of running an outdated control plane have increased sixfold"
      color="advisory"
      size="sm"
      icon={<Icons.Warning />}
      sx={sx}
      testId="control-plane-costs-alert"
    >
      <Typography variant="P12R">
        EKS clusters running Kubernetes versions within the extended support
        window are charged $0.60 per cluster per hour for the control plane,
        instead of $0.10.{' '}
        <Typography
          component="a"
          href={EXTERNAL_LINKS.external_docs_eks_control_plane_costs}
          target="_blank"
          rel="noopener noreferrer"
          variant="P12M"
          sx={{ color: 'inherit' }}
        >
          Learn more
        </Typography>
      </Typography>
    </Alert>
  );
};
